import { RoutePointStatus } from "../../models/enums/routePointStatus";
import { RoutePoint } from "../../models/routes/routePoint";
import { NextWorksId, Route } from "../../models/routes/route";
import { RouteStatus } from "../../models/enums/routeStatus";
import { isFlexibleOrderCheckList } from "../../models/routes/checkListConfig";
import InactivePoint from "./routePointViewCards/inactivePoint";
import SimplePoint from "./routePointViewCards/simplePoint";
import ActivePoint from "./routePointViewCards/activePoint";

type Props = {
    routePoint: RoutePoint;
    route: Route;
    number: number;
    onOpenPoint: () => void;
    isFirstPointFinished: boolean;
};

const inactivePointStatuses = [RoutePointStatus.Open, RoutePointStatus.Cancelled, RoutePointStatus.Rejected];
const hidePointStatuses = [RoutePointStatus.Cancelled, RoutePointStatus.Rejected];

const RoutePointView: React.FC<Props> = ({ routePoint, route, number, onOpenPoint, isFirstPointFinished }) => {
    if (hidePointStatuses.includes(routePoint.status)) return null;
    const isPointClosed = routePoint.status >= RoutePointStatus.Closed || route.status >= RouteStatus.WaitingForRouteSheet;
    const isFlexibleOrder = isFlexibleOrderCheckList(routePoint);
    const isPointInactive = isFlexibleOrder
        ? isFirstPointFinished
            ? false
            : inactivePointStatuses.includes(routePoint.status)
        : routePoint.status !== RoutePointStatus.Current && inactivePointStatuses.includes(routePoint.status);

    return (
        <div className="my-2">
            <div className="fw-bold">#{number}</div>
            {route.nextWorksCheckListId === NextWorksId.WaybillAndTimeSpentForBicycles &&
            routePoint.status !== RoutePointStatus.Cancelled ? (
                <SimplePoint pointClosed={isPointClosed} routePoint={routePoint} />
            ) : isPointInactive ? (
                <InactivePoint routePoint={routePoint} />
            ) : (
                <ActivePoint pointClosed={isPointClosed} routePoint={routePoint} onOpenPoint={onOpenPoint} />
            )}
        </div>
    );
};

export default RoutePointView;
